import { ActionContext } from 'vuex';
import Accessory from '@/interfaces/Accessory';

export type AccessoriesState = {
  discoveredAccessories: Accessory[];
};

export default {
  state: {
    discoveredAccessories: [],
  },
  actions: {
    discoveredAccessory(
      context: ActionContext<AccessoriesState, any>,
      { accessory }: { accessory: Accessory },
    ) {
      context.commit('accessoryAdded', { accessory });
    },
    accessoriesPairingSessionStarted(
      context: ActionContext<AccessoriesState, any>,
    ) {
      context.commit('cleanDiscoveredAccessories');
    },
    accessoriesPairedSessionFinished(
      context: ActionContext<AccessoriesState, any>,
    ) {
      context.commit('cleanDiscoveredAccessories');
    },
  },
  mutations: {
    accessoryAdded(
      state: AccessoriesState,
      { accessory }: { accessory: Accessory },
    ) {
      if (
        state.discoveredAccessories.find(
          acc => acc.macAddress === accessory.macAddress,
        )
      ) {
        return;
      }
      state.discoveredAccessories.push(accessory);
    },
    cleanDiscoveredAccessories(state: AccessoriesState) {
      state.discoveredAccessories = [];
    },
  },
};
